import 'bootstrap/dist/css/bootstrap.min.css';
import './staticElements.css';
import Logo from './images/icons/batteryLogo.webp';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

function Header() {
  return (
    <>
      {['md'].map((expand) => (
        <Navbar collapseOnSelect id="Start" key={expand} expand={expand} className=" mb-3 header">
          <Container fluid>
            <Navbar.Brand href="#" className='LogoCont'>
              <img src={Logo} alt='logo' />
              <span translate='no'>OrszAnt</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              restoreFocus={false}
            >
              <Offcanvas.Header closeButton  restoreFocus={false}>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  OrszAnt
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-5 Tabsy">
                  <Nav.Link href="#Kompensacja"><span>Kompensacja</span></Nav.Link>
                  <Nav.Link href="#Oferta"><span>Oferta</span></Nav.Link>
                  <Nav.Link href="#Kontakt"><span>Kontakt</span></Nav.Link>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default Header;